import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';

import NotFound from '@/views/NotFoundPage.vue';

const routes = [
  {
    path: '/',
    redirect: 'dashboard',
    component: DashboardLayout,
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "demo" */ '../views/Dashboard.vue')
      },
      {
        path: '/cards',
        name: 'cards',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/UserCards.vue')
      },
      {
        path: '/r-transfers',
        name: 'rtransfers',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/RTransfers.vue')
      },
      {
        path: '/s-transfers',
        name: 'stransfers',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/STransfers.vue')
      },
      {
        path: '/settings',
        name: 'settings',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Settings.vue')
      },
      {
        path: '/providers',
        name: 'providers',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Providers.vue')
      },
      {
        path: '/tools',
        name: 'tools',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Tools.vue')
      },
      {
        path: '/icons',
        name: 'icons',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Icons.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Login.vue')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Register.vue')
      },
      { path: '*', component: NotFound }
    ]
  }
];

export default routes;
